
import { reactive } from "vue";
import { IStore } from "./index";
/**
 * IUserState
 */
declare interface RouterList {
  redirect?: string,
  path: string,
  name: string,
  components: string,
  children?: Array<RouterList>
}
declare interface Router {
  router: Array<RouterList>,
  getRouter: Function,
  setRouter: Function
}

const storeRouter = reactive({
  router: [],
  getRouter() {
    let router = [],
        privilegeRouters = localStorage.getItem('privilegeRouters');
    if (typeof privilegeRouters === 'string') {
      router = JSON.parse(privilegeRouters)
    }
    
    return this.router.length >0 ? this.router : router 
  },
  setRouter(router: Array<RouterList>): void {
    this.router = router
  }
} as Router);
const store: IStore<Router> = {
  persistedState: false,
  state: storeRouter,
};
export default store;
export { storeRouter, RouterList };